<template>
  <div :class="{ 'overflow-hidden': appendToBody }" @click="$emit('click', $event)">
    <FormLabel v-if="label" :label="label" :error="!!error" />
    <v-select
      :id="id"
      ref="vselect"
      class="w-full h-9"
      :style="{ '--vs-border-color': !!error ? 'rgb(var(--color-alert))' : '' }"
      :disabled="disabled"
      :model-value="modelValue"
      :options="options"
      :loading="loading"
      :clearable="clearable"
      :label="labelKey"
      :searchable="searchable"
      :selectable="selectable"
      :reduce="defaultReducer ? (opt) => opt.value : reduce"
      :placeholder="placeholder"
      :appendToBody="appendToBody"
      :outlined="outlined || null"
      :rounded="rounded || null"
      :elevated="elevated || null"
      :dense="dense || null"
      :multiple="multiple"
      @update:modelValue="updateValue"
      @blur="onBlur"
      @keyup="onKeyup"
      @option:selected="$emit('option:selected', $event)"
      @open="$emit('open', $event)"
    >
      <template v-slot:list-footer>
        <div
          v-if="showAddButton"
          style="bottom: -1px"
          class="flex sticky justify-center w-full cursor-pointer py-1 bg-gray-100 text-secondary hover:text-primary border-t border-solid border-gray-200"
          @click="$emit('add')"
        >
          {{ $t('add_new') }}
        </div>
        <slot v-else name="list-footer"></slot>
      </template>
      <template v-slot:selected-option="item">
        <span v-html="item.label"></span>
      </template>
      <template v-slot:no-options>
        <div class="py-1">No items available</div>
      </template>
      <template v-slot:option="{ label, badge1, badge2 }">
        <div class="flex py-0.5 justify-between items-center">
          <div>{{ label }}</div>
          <div>
            <Badge v-if="badge1" info small :text="badge1" class="ml-2"></Badge>
            <Badge v-if="badge2" info small :text="badge2" class="ml-2"></Badge>
          </div>
        </div>
      </template>
    </v-select>

    <label v-if="error || $slots['error']" class="text-12 text-alert mt-3 mb-1">{{ error }} <slot name="error"></slot></label>
  </div>
</template>

<script>
import ValidationMixin from '../mixins/ValidationMixin.js';
import FormLabel from './FormLabel.vue';

export default {
  name: 'FormSelectMultiBadge',
  components: { FormLabel },
  mixins: [ValidationMixin],
  emits: ['click', 'update:modelValue', 'option:selected', 'blur', 'keyup', 'add', 'open'],
  props: {
    disabled: Boolean,
    modelValue: {
      type: [String, Number, Object, Array],
    },
    options: Array,
    clearable: Boolean,
    searchable: Boolean,
    appendToBody: Boolean,
    reduce: Function,
    selectable: Function,
    defaultReducer: Boolean,
    label: String,
    labelKey: String,
    error: String,
    placeholder: String,
    elevated: Boolean,
    outlined: Boolean,
    rounded: Boolean,
    dense: Boolean,
    id: String,
    multiple: Boolean,
    showAddButton: Boolean,
    loading: Boolean,
  },
  methods: {
    updateValue(value) {
      this.eventbus.emit('input', value);
      this.$emit('update:modelValue', value);
    },
    onBlur($event) {
      this.eventbus.emit('blur', $event);
      this.$emit('blur', $event);
    },
    onKeyup($event) {
      this.eventbus.emit('keyup', $event);
      this.$emit('keyup', $event);
    },
  },
};
</script>

<style lang="scss">
.v-select {
  .vs__dropdown-toggle {
    min-height: 36px;
  }
}
</style>
